import React from 'react'

import { makeStyles } from '@mui/styles'
import {
  StaticDatePicker,
  LocalizationProvider,
  PickersDayProps,
  PickersDay,
} from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import 'moment/locale/en-gb'

import { setDisplayedDateAndCursor } from '../../actions/trackerActions'
import { DateTimeFormat } from '../../consts'
import { useSelector } from '../../hooks/useSelector'

import { daysAssignedSelector } from './worklogsHeaderSelectors'

const useStyles = makeStyles((theme) => ({
  savedDay: {
    position: 'absolute',
    height: 0,
    width: 0,
    border: '2px solid',
    borderRadius: 4,
    borderColor: theme.palette.primary.main,
    right: '50%',
    transform: 'translateX(1px)',
    top: '80%',
  },
  dayContainer: {
    position: 'relative',
  },
  unsavedDay: {
    position: 'absolute',
    height: 0,
    width: 0,
    border: '2px solid',
    borderRadius: 4,
    borderColor: 'red',
    right: '50%',
    transform: 'translateX(1px)',
    top: '80%',
  },
}))

export const HeaderCalendar = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const displayedDate = useSelector((state) => state.displayedDate)
  const daysAssigned = useSelector(daysAssignedSelector)

  const renderDayInPicker = (
    day: moment.Moment,
    selectedDays: moment.Moment[],
    pickersDayProps: PickersDayProps<moment.Moment>
  ) => {
    if (moment(day).isSame(displayedDate, 'day'))
      return <PickersDay {...pickersDayProps} />

    const formattedDate = moment(day)
      .startOf('day')
      .format(DateTimeFormat.LONG_DATE)

    if (daysAssigned[formattedDate] === true) {
      return (
        <div key={pickersDayProps.key} className={classes.dayContainer}>
          <PickersDay {...pickersDayProps} />
          <div className={classes.savedDay} />
        </div>
      )
    }

    if (daysAssigned[formattedDate] === false) {
      return (
        <div key={pickersDayProps.key} className={classes.dayContainer}>
          <PickersDay {...pickersDayProps} />
          <div className={classes.unsavedDay} />
        </div>
      )
    }

    return <PickersDay {...pickersDayProps} />
  }

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <StaticDatePicker
        renderInput={() => <></>}
        onChange={(date) =>
          date && dispatch(setDisplayedDateAndCursor(date.toISOString()))
        }
        value={displayedDate}
        renderDay={renderDayInPicker}
        disableFuture
        displayStaticWrapperAs="desktop"
      />
    </LocalizationProvider>
  )
}
